var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2, _path14, _g3, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-fk",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 444.4,
    x2: 470.9,
    y1: 592.2,
    y2: 577.1,
    gradientTransform: "scale(1.003 .997)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 851.8,
    x2: 646.2,
    y1: 369.9,
    y2: 369.9,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 458.2,
    x2: 520.5,
    y1: 562.5,
    y2: 552.8,
    gradientTransform: "scale(.936 1.068)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: 472.4,
    x2: 445.3,
    y1: 578.7,
    y2: 580.2,
    gradientTransform: "scale(1.003 .997)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 518,
    x2: 456.4,
    y1: 553.7,
    y2: 558.1,
    gradientTransform: "scale(.936 1.068)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "h",
    x1: 388.5,
    x2: 677.4,
    y1: 507.2,
    y2: 508.8,
    gradientTransform: "scale(.823 1.215)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "i",
    x1: 579.8,
    x2: 556.8,
    y1: 504.9,
    y2: 505.9,
    gradientTransform: "scale(.835 1.198)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    x1: 581.4,
    x2: 558.9,
    y1: 512,
    y2: 514.3,
    gradientTransform: "scale(.823 1.215)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "k",
    x1: 552,
    x2: 589.8,
    y1: 517.9,
    y2: 503.9,
    gradientTransform: "scale(.835 1.198)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 444.4,
    x2: 470.9,
    y1: 592.2,
    y2: 577.1,
    gradientTransform: "scale(1.003 .997)",
    gradientUnits: "userSpaceOnUse"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 10,
    d: "M671 321.6a13.2 13.2 0 0 0-2 .1c-3.4.6-8.8 11.7-11.7 18.2-4.7 5.6-7.1 10-9 13.2-.8 1.3-2 2.7-1.6 4.4-7 1.7-7.4 7.7-7.4 10 0 2.6.8 3.8.8 3.8l4.2 7.8v.1c4.5 9.3 11 21.7 14.8 22.7 5.2 1.5 18.8-3.5 29-12.2a164 164 0 0 0 62 12.6c23.8 0 45.2-5.7 61.9-12.6 10.2 8.7 23.7 13.7 29 12.2 3.7-1 10.3-13.5 14.8-22.7l4.1-7.9s.8-1.2.8-3.7c0-2.3-.4-8.4-7.4-10 .4-1.7-.7-3.2-1.5-4.5-2-3.3-4.4-7.7-9-13.4-3-6.5-8.4-17.4-11.7-18-4.8-.8-15 1.6-15 2.5v.5L795.4 344c0 .5 1 14.5 5 27a147 147 0 0 1-50.5 8.5c-19.8 0-36.7-3.5-50.4-8.6a136 136 0 0 0 5-27L684 324.7v-.5c0-.7-7.9-2.6-13-2.6zm5.2 24c2.6 0 5.3 2.2 7.6 4.5l-.2 1.4a78.7 78.7 0 0 1-3.2 10.6 85.8 85.8 0 0 1-14.3-10.3c2.2-2.4 5.8-5.6 9.6-6.1h.5zm147.6 0h.5c3.8.6 7.4 3.8 9.7 6.2a85.6 85.6 0 0 1-14.4 10.3 78.3 78.3 0 0 1-3.2-10.6 17 17 0 0 1-.2-1.4c2.2-2.4 5-4.5 7.6-4.5zm-166 27.4c2.7 2.1 6.3 4.5 10.6 7a12.3 12.3 0 0 1-3.8 1.7c-1.8.4-3.6.3-5.5-.1a17.5 17.5 0 0 1-1.2-5.7 70.3 70.3 0 0 1-.1-2.9zm184.5 0-.2 2.9a17.6 17.6 0 0 1-1.2 5.7 12 12 0 0 1-9.3-1.6c4.4-2.5 8-4.9 10.7-7z",
    transform: "matrix(.952 0 0 .952 -323.6 17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M445.6 595.5s5.7-8.8 10.3-8.1c4.7.6 9.1 6.2 9.4 6.5a41 41 0 0 0 6.9-7.5c-.3-.3-7.2-16.5-11-17.2a24.7 24.7 0 0 0-11.8 1.8z",
    transform: "matrix(-1.204 0 0 1.26 868.6 -393.2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M433.1 586.1c0 .6 2 23.8 10 31.9 8 8.1 21.3 13.1 26 11.9 4.6-1.3 15.3-24.7 15.3-24.7s-11.3 11.2-19.7 9.3c-8.4-1.8-13.4-15.9-15-22.8-1.6-6.8-.3-20.3-.3-20.3L433 586.1z",
    transform: "matrix(-1.204 0 0 1.26 868.6 -393.2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M445.6 595.5s5.7-8.8 10.3-8.1c4.7.6 9.1 6.2 9.4 6.5a41 41 0 0 0 6.9-7.5c-.3-.3-7.2-16.5-11-17.2a24.7 24.7 0 0 0-11.8 1.8z",
    transform: "matrix(1.204 0 0 1.26 -87.7 -393.2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M433.1 586.1c0 .6 2 23.8 10 31.9 8 8.1 21.3 13.1 26 11.9 4.6-1.3 15.3-24.7 15.3-24.7s-11.3 11.2-19.7 9.3c-8.4-1.8-13.4-15.9-15-22.8-1.6-6.8-.3-20.3-.3-20.3L433 586.1z",
    transform: "matrix(1.204 0 0 1.26 -87.7 -393.2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M656.4 338.6c-4.7 5.7-7.2 10.2-9.2 13.5-2 3.3-.8 8 3.7 14.5 5 7 45.4 34.7 98.1 34.7 52.7 0 93.1-27.6 98-34.7 4.6-6.6 5.8-11.2 3.8-14.5-2-3.3-4.5-7.8-9.2-13.5 0 8.6-33.5 40-92.6 40-59.1 0-92.6-31.4-92.6-40z",
    transform: "matrix(.952 0 0 .952 -322.6 18)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m467.8 625.5 7.2-11.9-3.6-2.5c-1 3-5.1 4-5.8 7.8-.7 3.8 2.8 7.5 2.2 6.6z",
    transform: "matrix(1.204 0 0 1.26 -87 -392)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M475 623s1.3-5.3-2.8-6c-4-.6-6.2 3-5.6 1.6.6-1.6 3-3.1 3.4-8.4.3-5.3-.3-8.2-.3-8.2s1.6-6.8 8.1-5.9c6.6 1 6.9 6 6.9 7.8 0 1.8-.6 2.8-.6 2.8z",
    transform: "matrix(1.204 0 0 1.26 -87.7 -393.2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m456.8 366.1 1.6 2.9 1-.7-.7-1.8.2-.4 1.9-1.2 4.8 8.7v.4l-1 .7.5.8 4.6-3-.4-.8-1 .6h-.5l-4.8-8.7 1.8-1.2h.4l1.2 1.6 1-.7-1.6-2.8-9 5.7zm-11.7 6.7.4.8 1-.4.4.1 4.2 8.8v.4l-1 .6.4.8 4.6-2.4-.4-.9-1 .4h-.4l-2-4.2 4.7-2.4 2 4v.4l-1 .7.4.8 4.7-2.4-.4-.8-1 .4-.4-.2-4.3-8.7.1-.4 1-.6-.4-.8-4.7 2.4.4.8 1-.4.4.1 1.8 3.6-4.7 2.5-1.8-3.6.2-.4.9-.6-.4-.8zm-2.7 7.5.3.8 1.3-.3.4.2 1 3.6-1 .4c-2.6.8-4.8-.5-5.7-3.7-1-3.1.1-5.5 2.7-6.3a4 4 0 0 1 1.6-.1l.3.2 1 1.7 1.2-.4-.8-3c-1.5 0-2.8.2-4 .6-3.8 1.3-5.6 4.4-4.6 8.1 1 3.7 4.3 5.4 8 4.2a12.6 12.6 0 0 0 3.7-2l-1.2-4 .2-.3 1-.4-.2-1zm-10.8 10.2 5.2-1.6-.2-1-1.3.3-.3-.1-2.8-9.5.1-.3 1.2-.5-.3-.8-5.2 1.6.2.8 1.3-.2.3.1 2.8 9.5-.2.3-1 .5.2.8zm-28.4 4.6 9.2-.8-.3-3.3H411l-.2 2-.2.4-4 .4-.4-5h2.3l.3.2.2 1.3h1l-.3-4.4h-1v1.4l-.3.4-2.2.1-.4-4.4 3.4-.2.3.1.3 1.7 1.2-.1-.2-3-8.6.9v.8h1.1l.2.3.9 9.8-.2.3-1 .2v1zM389.4 383v1h1.1l.2.3.2 9.8-.2.3-1 .2v.8h4.9v-.9h-1l-.4-.4v-4.6l4.9-.1.1 4.6-.2.4h-1v1h4.8v-1h-1l-.3-.4-.1-9.8.2-.4h1v-1h-4.9v1l1 .1.4.3v4l-5 .1v-4l.3-.3h1v-1zm-10.4-.3v3.3h1.2l.3-2 .2-.2h2v10l-.3.4h-1.1v1h5.1v-.8l-1.1-.2-.3-.3.1-10h2l.4.2.2 2h1.2v-3.2zm-15.9 10.5 9 .4.1-3.2-1-.1-.4 2-.3.2-3.9-.2.3-4.9 2.2.2.1.2.2 1.4h1l.1-4.2h-1l-.2 1.2-.2.2h-2.2l.2-4.4 3.3.1.2.3.3 1.6h1.1V381l-8.3-.4v1l1 .1.2.3-.4 9.8-.3.3h-1v1zm-20.6-5.4 4.7 1.7.3-.9-1-.4-.2-.4 2.9-9.4.3-.2 1.2.3.2-.9-4.8-1.6-.3.8 1 .5.3.3-3 9.4-.3.3-1-.4zm-8.6-3.2a9.3 9.3 0 0 0 3 1.6c2.6.8 4.7-.2 5.4-2.2a3.4 3.4 0 0 0-.7-3.2c-.8-1-1.5-1.5-1.9-2-.7-.8-1-1.6-.8-2.4.3-.9 1.3-1.4 2.5-1l1.1.7v.3l-.2 1.9 1.2.4.8-2.8a9 9 0 0 0-2.8-1.7c-2.3-.8-4.2.3-4.9 2.2a3.5 3.5 0 0 0 .4 2.8c.6.9 1.3 1.5 1.8 2 1 1 1.3 1.9 1 2.8-.3 1-1.3 1.5-2.6 1a4.5 4.5 0 0 1-1.3-.8l-.2-.3.4-2.2-1.2-.4zm-10.8-4.6 8.2 4 1.3-3-1-.4-1 1.6-.3.2-3.6-1.8 2-4.3 2 1v.3l-.3 1.3.9.5 1.7-4-.8-.4-.8 1.1-.3.2-2-1 1.8-4 3 1.5.2.4-.5 1.5 1 .5 1.3-2.6-7.7-3.8-.3.8.8.5.2.5-4 8.8-.4.1-1-.3-.3.8zm-1.3-14.8-4-2.9-.6.8.9.7v.4l-5.2 8.1-.4.1-.8-.5-.6.9 4.1 2.7c1.5 1 2.7 1.5 4 1.3 1.7-.1 3.3-1.1 4.4-3 2-3.2 1.5-6.4-1.8-8.6zm-1.7 0 .8.6c2.2 1.5 2.4 3.7.6 6.5s-3.9 3.6-6 2l-.9-.4 5.5-8.6zm32.6 12.9-.2.8 1 .3.2.3-2 9.6-.3.3-1-.1-.2.8 4.7 1 .2-.7-1-.4-.3-.4.8-4h.4c1.6.4 2 1.3 2 3.1 0 1 0 1.7.8 2.7.3.4.8.8 1.7 1a11.2 11.2 0 0 0 1.6.2l.1-.9h-.1c-1.2-.3-1.6-.7-1.7-1.7-.1-1 0-2-.4-3a2.9 2.9 0 0 0-1.5-1.5c2 0 3-.8 3.4-2.4.4-2-.6-3.4-3.2-4l-5-1zm3.2 1.7.7.1c1.6.4 2.3 1.4 2 2.9-.4 1.7-1.3 2.3-3.1 1.9-.2 0-.4 0-.6-.2l1-4.7zm60.4 1 .1 1h1.4l1.6 9.9-.3.2-1 .3.1.8 5-.8v-.9l-1.2.1-.3-.2-.6-4.1h.3c1.8-.4 2.4.3 3.3 2 .4.8.6 1.6 1.7 2.2.5.2 1.2.4 2 .2a13.4 13.4 0 0 0 1.8-.5l-.2-.8h-.2c-1.2.2-1.8 0-2.4-.9-.5-.8-.8-1.8-1.4-2.5-.5-.5-1.2-.8-2-.8 1.9-.8 2.8-2 2.5-3.7-.3-2-2-2.9-4.7-2.5zm3.9.4h.8c1.7-.4 2.8.3 3 1.8.2 1.7-.5 2.6-2.4 3h-.7l-.8-4.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m467.8 625.5 7.2-11.9-3.6-2.5c-1 3-5.1 4-5.8 7.8-.7 3.8 2.8 7.5 2.2 6.6z",
    transform: "matrix(-1.204 0 0 1.26 867.9 -392)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M475 623s1.3-5.3-2.8-6c-4-.6-6.2 3-5.6 1.6.6-1.6 3-3.1 3.4-8.4.3-5.3-.3-8.2-.3-8.2s1.6-6.8 8.1-5.9c6.6 1 6.9 6 6.9 7.8 0 1.8-.6 2.8-.6 2.8z",
    transform: "matrix(-1.204 0 0 1.26 868.6 -393.2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072c4",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 3.9,
    d: "M396.9 606s-75.5-21.4-75-102.2l.5-107h148.9l.5 106.4c.5 80.8-75 102.7-75 102.7z",
    transform: "matrix(1.204 0 0 1.26 -87.3 -390)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M313.3 140.1c.2 0 1.2-1 2.3-2 1.4-.7 2.7-1.6 4-2.4 1.2-.5 3.3-1 4.2-1.5a10.2 10.2 0 0 0 3.5-2.7c.1-1.8.4-3.1.4-5.1l4-2c2-.6 2.3-1.3 4.2-1.6 1.2-.4 3.2-.4 4.9-.4 1.9 0 3 1.4 4.7 1.6 2 .8 3 1.4 4.6 2.8.8 1.1 1.4 2 3 2.9 1.1.7 2.3 1.6 3.7 2 1.6.9 2.9 1.4 4.1 2.7 1.2.8 1.7 2 2.6 2.8a29.4 29.4 0 0 0 3.9 2.8c1.6 1 3.2 1.8 5.7 1.6 1.4 0 2.9-.2 4.5 0 1.9 0 3.7 0 5.3.5 2 0 3.5.2 5.3.4 1.7.3 3.4.3 5.2.3 1.7.5 3.5.4 5.3.4h10.6c2 0 3.9.1 5.2.4a41.6 41.6 0 0 0 5.3-.4c2 0 3.6-.3 5.7-.4h6.3c1.7.5 3.8.8 5 1.7 1.5.4 2.2 1.1 3.7 1.6a10.6 10.6 0 0 1 3.8 2.7 20.1 20.1 0 0 1 3 4.3c1 1.5 1.4 3.3 2.2 5.1.4 1.8.8 3.5.8 5.5.4 1.7.4 3.6.4 5.5-.5 1.8-.5 3.8-1.2 5.5 0 2-.4 3.7-.7 5.1-.3 1.7-.8 2.7-.8 4.8v5.5c0 1.8-.5 3-.7 5a57.9 57.9 0 0 0-2.7 6 12 12 0 0 0-3 3c-.8.7-1.2 1.4-1.1 1.7 1.5.5 1.1 1.6 1.1 3.5.2 1.6.3 3.5.8 5.2.1 1.8.5 3 1 4.3.7.8.9.4-.7.4-1 .8-2.2.4-2.6-1.2a9.8 9.8 0 0 1-1.5-4.4c-.2-1.7-.5-3.5-1-4.7-.3-2.2-.9-2.2-3-2.3-1.1-1-2.5-1.2-4.6-1.2-2 0-2.2-.2-2.3 2v5.5c-.4 1.6-1 2.9-1.5 4.3-1.1.8-1.6 2.2-3 3.1-.7 1.8-1.6 2.1-3.4 2.5l-2.2-2.8c1-1.8 2-2 2.6-4 .8-1.5 1.3-2.5 1.8-3.9-.8-1.2-1.4-1.8-2.2-3.5a21.4 21.4 0 0 1-2-4.3c-1.1-.5-3-.6-4-1.2-1.9-.5-2.3 1.6-4.5 1.6H404c-2.3 0-2.9 1.2-4.9 1.1-.6.2-2 0-4.1 0-1.6.6-3.5.4-5.3.4-1.9 0-3.4-.5-4.9-.8-1.7-.5-3.4-1-5.2-1.1-2.3 0-3.1.1-4.6 1.1-1.1.7-2.8 2.3-4 3.2-.6 1.3-.9 3.5-1.7 5-.3 1.7-1 2.6-1.5 4a15 15 0 0 0-1 4.8c-.2 2.6-.7 2.3-2.3 1.5-.6-1.1-1.6-2.3-2.3-3.6.4-2 .8-2.9.8-5-.4-1.7-1.2-1.5-2.2-.4 0 2 0 3.6-.9 4.7a4.9 4.9 0 0 1-2.2 3c-.5 1.6-1.8 2.3-3 2.9v-1.7c-.9-1.7 0-3.2 0-5.4 0-2-.1-3.3.4-5 0-2-.8-3.8-1.1-5.2-.7-1.5-1.1-2.2-3-2.8-1.4-.6-3.3-1.2-4.2-2.4a7.8 7.8 0 0 0-3.4-2.7c-1.6-.6-2.5-1.2-3.8-2-1-1.3-2-1.8-2.6-3.5-.8-1.2-.9-3.5-1.4-5.1a17.7 17.7 0 0 0-1.2-4.7 19.8 19.8 0 0 0-1.1-4.8l-1.1-5.1c0-1.9 0-3.8-.5-5.5v-5.5c-.2-1.6-.3-4-.7-5.1 0-2.2-.2-3.3-.8-4.8-.8-1.4-.8-2-2.2-2.3-1 1.2-2.5 1.8-4.5 2-1.4-.3-3.3-.6-4.9-1.2-1.5-.3-2.5-1-3.7-1.6a35.2 35.2 0 0 0-2.3-3.1c-.3-2-.7-3.1-.8-5.2 0-1.4 0-.6 1.6-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "m335.6 154.3.3-.3c-.7.6-.4.3 1-.3.9-.4 2.4-1.3 3-2 .6-.2 1.8-.7 2.4-1.3.7-.8 1.4-1.5 2.4-2.2 1-.9 2-1.2 3.2-2 1.4-.1 2-.8 3.4-.3 1.3.3 1.9.3 3-.8 1-.6 2.2-1.4 2.6-2.4v-1.8c0 1.8-.4 2.5-1.6 3-.8 1.1-2 2.2-2.4 3.2-.9 1.2-1 1.8-1.8 2.4-.8.9-2 1.4-2.2 2.9.4.6 0 1 .9 1 .7.7 1.5.4 2.6 0a11.6 11.6 0 0 0 2-3.2l2-2.9c1-.6 1.5-1.1 1.8-2.2 1-.6 2-1.3 2.7-2 .8-.4 1.2-.8 2.4-1a4.9 4.9 0 0 1-.8 3c-.3 1.6-.2 2.3.3 3.3.7.5.6 1 1 2 .5-1 .7-2.8.9-4v-.2c0 1.2 0 2.8-.4 3.6 0 1.7.5 2.4.9 3.6.4.7.8 1 1.3 1.4 0-1.6.5-2.6.5-4 .4 1 .3 2.5.5 3.8.1 1.3.6 2.2 1 3.3.7.3.9 1.5 1.1.6.7-2 .7-4.1 1.1-6.1 0-1.1.2-2.6.6-3.4l-.6 3.3c0-1 .2-2.5.6-3.3v-.3a31.8 31.8 0 0 1 .5 4.5c0 1.2 0 2.4.3 3.6.8-.4 1.4-1.4 1.9-2.5a14.8 14.8 0 0 1 2-3l-2 3a14.8 14.8 0 0 1 2-3v-.3a32.8 32.8 0 0 0-.2 3.8c0 1.3 0 2.8.3 3.7.3 1.4.7 1.7.8 3.2 0 .8-.2 1.7.2 2 1.2.3 1.2-.3 1.3-1.9 0-1.8.5-3 .6-4.7 0-2.1.3.2.5 1a10.6 10.6 0 0 1 .8 3.7c0 .8 0 1.6.3 2 1-.5 1.4-1.7 2-2.3l1.7-2.8c1.4-.2 1.3-.8 1.3-2.4 0-1.4 0-2.8.3-4a33.4 33.4 0 0 0 1.1-3.6c.5-.3 1 .5 1.3 1.1.6 1 .5 2.2.5 3.6a17 17 0 0 0 1.4 3.4 12.2 12.2 0 0 0 1.9 2.7c.2 1 .2 2.5.2 3.7 1-1.2 1.2-3 1.3-4.7-.2-1.2-.2-2.8-.5-4a13 13 0 0 0-.6-3.3c-.8-.4-1-.8-.2-2 .8-.7 1.8-.3 3.2-.2.7.8 1 1.2 1 2.8 0 1.5 0 2.6.6 3.6.5.8 1 1.4 1.3 2.7.4.5.7 1 1.3.4.3-.8.6-2.5.8-3.4.3-1 .8-1.6 1.3-2 0 1.6 0 2.5.6 3.7l1.3 3c.6.5.7 1.3 1.4 1.7.2-1.3.2-2.8.2-4.4v-4c.1-1.2.4-2 .9-3 .8 1.1.8 1.5.8 3 .8-.3 1-.9 1.3-1.9.5-.6.8-.8 1 .6l.8 4.1c.5.7 1.2 2.2 1.8 2.8a13.4 13.4 0 0 0 1.7 2.3c.4.8.5 1.4 1.6 1.6 0-1.8 0-3.7-.3-5.5 0-1.6-.4-2.2-.5-3.7-.5-.9-.7-2.3-.6-2.8a9 9 0 0 1 2.5 3.4l1.6 3.7a16.3 16.3 0 0 1 2 2.7c1 .8 1.5 1.7 2.5 2.5.5.5 1.6.8 1.8.5 0-1.6-.3-3-.8-4.4a7.3 7.3 0 0 0-.8-3.3c-1-.9-1.9-1.5-2.4-2.8-.4-.4-.4-.6-.5-1.4a21.4 21.4 0 0 1 3.7 3.9 5.7 5.7 0 0 0 2.2 2c.4.6 2 1.3 3.1 1.6a4.6 4.6 0 0 0 2.7 1.7l-2.7-1.7a4.6 4.6 0 0 0 2.7 1.7v.3a10.6 10.6 0 0 0-1.6-4.5 7.2 7.2 0 0 0-2.5-3 7.6 7.6 0 0 0-2.6-2.5c-.7-.8-1.8-2.3-2.4-2.8 1.2-.8 2.5.5 3.7 1 1.1 1.2 2 2.7 2.7 3.4a14.7 14.7 0 0 0 2.5 3.7c1.1.6 1.8 1.3 2.8 2.2 1.7.4 1-.2.6-1.4-.6-1.6 0-1.6 1-.6.8.6 1.7 1.4 2.7 2 .5.5 1.2 1 1.8.5.4-.4.4-.4.4-.8-.6-1.8-1.2-3-2.5-3.6-.6-.9-1.6-1.7-2.4-2.5l-1.6-2.3 1.7 2.2c-.6-.8-1.2-1.2-1.7-2.2h-.2c1.6 0 2.2.5 3.4 1.2a5.5 5.5 0 0 1 2.4 2c.5.6 1.4 1.3 2 2.1l2.5 2c1 1.1 1 1.9 1 3.6.7.8.7 2.4 1 3.3-.3 1.6-.8.3-1-.6 0-1.2-.6-1.1-1.5-.8 0 1.7.2 2.1.8 3.4a6.5 6.5 0 0 1-1 2.7c-.7.4-.8-.8-1.4-1.3 0-1.7-.5-2-1.6-2.8v1.1c.6 1.2 1.3 2.2 1.4 3.9a9.8 9.8 0 0 1 .5 3.6c0 1.4 0 2.7-.3 4l-.2 3.5v7.8a19 19 0 0 0-.3 3.6l.3-3.6c-.2 1-.3 2.2-.3 3.6v.3c-.5-1.4-1-2.6-1.4-4.1a8.4 8.4 0 0 1-1.8-2.9l-.5-3.5c-.4-1-.8-2-1.7-1.4-.3 2 .2 3.2.9 5.2.4 1.3.4 2.4.8 3.7.6 1.4 1.1 1.6 0 3.2-.6 1-.8 1.2-1 2.3-1 .5-1.3.8-1.4 2-.3-1.1-1.1-2.4-1.6-3.6l-1.3-4c-.7-1-1.4-2.4-2.1-3-.8-.9-1.7-2.5-2.2-3.3-1-1.2-1.3-2-2.2-2.5-.1-.6-.4-1.3-1-.8 0 1.3 0 2.7.3 3.8.3 1.6.7 2.5.8 4.1v3.1c-.6-1.6-1.4-2.9-1.9-4.4-.6-.9-1-2.5-1.8-3-.5-1.2-.8-2-1.4-2.8-.1-.8-.5-.8-.8-1.4 0 1.5.5 2.1.8 3.3a6.5 6.5 0 0 1 .6 3.4c-.7-2-1.3-4.1-2.2-5.9-.8-1.1-1.6-2.6-2-3.7-.9-.9-1.7-1-2.5-1.6a4.8 4.8 0 0 1-1.8-1.4c.1 1.5.7 2.5 1 3.6.2 1.4.9 2.5 1.1 3.7-.3 1.9-.8-.6-1-1.4a8.6 8.6 0 0 0-1.4-3.3c-.8-.6-1.3-1.5-2.2-2-.8-.3-.5 0-.5 1 0 1.8 0 3 .5 4 .6.8.6 1.8.6 3.3 0 1.4-.3 2.5-.3 4v2.1c-.6-1.1-1.2-1.9-1.6-3.3-.9-1.3-1.2-2.2-1.8-3.6-.6-.3-1.7-.5-2.2 0 .1 1.4.8 2 .9 3.6-1.1 1-1 1.4-1.7-.3-.5-1.3-1.3-1.2-2.1-2-1.3 0-.9-1-1.3-2.2 0-1 0-2.1-.3-3-1.5 0-2.3 0-3.2.8-.4.8-.2 2.4 0 3.7v3.8c-.3 1-.8 1-1 2.3-.6 1.1-.7 2.4-1.1 3.2-1 1-.6 1-1-.5v-9l.2-3.5c-.5-1.1-.7-1.4-2.5-1.4-.3.7-.1 2 0 2.8 0 1.4.2 2.7.3 3.6 0 1.5.2 2.4.3 3.6 0 1.5-.3 2.6-1 3.3-1 .3-.2 1-1.1 1.2a12.2 12.2 0 0 1-3-2c-1-.3-2-.5-3.4-.5-1.8 0-1.8-.3-2.4-1.6a25.6 25.6 0 0 1-1-4.5c-.7-1.3-.8-2.2-1-3.7a5 5 0 0 0-1.7-2c-.4 1.5-.8 2.7-.8 4.3-.3.6-.4 2.3-.5 3-.6-.8-.8-2.4-1.1-3.6-.5-1.6-1-2.7-2.7-2.2-1.7 0-1.8 0-1.8 2l2 3.2v4c0 1.6.2 2-1 2.4-.4-1.6-1.4-3.3-2.4-4.7-.1-1-.4-.8-1.6-.8-.7 0-1.4-.1-1.8.3v2.4c-.7.2-.9 0-1.3-.5-.5.8-.1 2 0 3a9.3 9.3 0 0 1-1.3 3.1c-.2-.4-.5-.2 0-.2l-5-1.6c-.8 0-1.5.9-2 1.6-1.4.4-2 .8-3.5.8-1.4 0-2.1.3-3.4.3-1 .2-2.2.3-3.5.3-.7-.3-2-.3-2.4-.6.6-.8 1.2-1.2 1.7-2.4a16.3 16.3 0 0 0 2-2l2.2-2.3c.4-1.4 1-1.6 1.9-2.2 1.6 0 1.8.6 3.4.8 1.5.6 2.4.9 3.3-.3 1.2-.5 2.2-1.4 3.6-1.6l2.7-1.6c1.2-.8 1.6-1.5 2.6-2.3.3-1.2 1.2-2 .8-3.3-1.4-.4-2.3-.3-3.2.5-1 1-1.3 1.4-2.6 2.2-1 .3-1.7.8-3 1.2-1 .4-2.4.2-3.6.2s-2.8 0-3.5.3a15 15 0 0 1 3.7-2c1-.7 1.5-1 3-1 .6-.9 1.3-.9 1.6-2.3.4-1.6-1-1.1-2.2-.5-1 .2-2.3 1-3.2 1.3a11.7 11.7 0 0 1-3.4.6c-.4-.5.2-.9.5-1.6 1.2-.5 1.4-.7 1.6-2-1.4.2-2 .7-3.3.8-1.3.4-2.7.5-4.2.6h-3.7c-1.3 0-2-.3-3.5-.3-1-.6-1-.8-1-2.5.8-1 1.6-.8 3.2-.8l2.9-1.4c1-.2 1.6-.6 1.4-1.1H342c-1.5-.7 0-.9.8-1.4 1.3 0 2.6 0 3.5.5 1.6 0 2.2-.6 3.5-1.6 1-.8 1.4-1.4 2.6-2 .8-.9 1.6-1.4 2-2.2 1.2-1 2-1.6 2.5-2.5.7-.4 1.2-.8.8-1.4-1.7.2-2.4.8-3.5 1.6a8.1 8.1 0 0 1-2 1.7 6.7 6.7 0 0 1-3.5 1.2c-1.4 0-2.4-.3-3.8-.3-1.4-.2-.1-.5.3-1.2.6-.3 1-1.2.6-1.9-1.2-.4-2.5-.3-3.8-.3h-3.7c-1.4 0-2-.3-3-.8-.2-.8 0-.6 1-.6a14.7 14.7 0 0 0 3.6-.5c1.2-.4 1.4-.9 1.6-2.2-1.3 0-2.7 0-3.5-.3zm-23-6.3c-.3-2-.7-3.1-.8-5.2 0-1.4 0-.6 1.5-2.7.2 0 1.2-1 2.3-2 1.4-.7 2.7-1.6 4-2.4 1.1-.5 3.3-1 4.2-1.5a10.2 10.2 0 0 0 3.5-2.7c0-1.8.3-3.1.3-5.1l4.1-2c2-.6 2.3-1.3 4.2-1.6 1.2-.4 3.2-.4 4.9-.4 1.9 0 3 1.4 4.7 1.6 2 .8 3 1.4 4.5 2.8.9 1.1 1.5 2 3 2.9 1.2.7 2.4 1.6 3.8 2 0 1.4.3 1.2-.7 1.2-.2 1.4-.5 1.4-1.9 1.4a6.5 6.5 0 0 1-2.4-2.2c.6-1.5.2 1.1 0 1.6-.7.6-1 1.1-1.8.6-.5-1.4-.8-2.3-.8-4-.3-1.7-.7-.4-1 .3-.5 1.5-.3 2 .2 3.1l-3.5-.2c-1-.3-2 0-3.2.4-1.4 1-1 1-.3 2 1.3.4 2.2 1 3.3 1.6 1.1-.1 2.4-.5 3.7-.8 1.3-.4 2.4 0 3.7 0 .7.4 1.5.5 1.9.8 0 1 0 1.8-.3 2.3-.5.4-1 1.4-2 1.6a13.1 13.1 0 0 1-3.6 1.5c-1.6 0-2.3.4-3.5 1-.1 1.5-.6 1.9-1.9 2.3a8.4 8.4 0 0 1-3.6.9c-.8 0-1.6 0-1.9-.4a10.4 10.4 0 0 0 2.1-3.2c.3-.6.8-1 .3-1.5-1.6 0-2 0-2.2 1.6-.1 1.6-.7 1.8-1.8 2.3.3-1.3.4-2.4.8-3.6a20.4 20.4 0 0 1-3.4.3c-.8.6-1.2.7-.8 1.6-1.1.4-2.5.2-3.8 0-1.1 0-.5-.5-1.3-1-.6-1.1-1.1-1.4-2.4-1.4-.6.8-1.7 1-2.4 1.6-1.2.4-1.9 0-3-.5-1.2 0-1 .4-.8 1.4.6.3 0 .7.9.8.8.7 1.4.8 2.9.8 1.1-.2 2.4-.2 3.7-.2 1.3 0 1.1.3 1.1 1.6-.8.7-2.1.6-3.5.6a13.5 13.5 0 0 1-3.2-.8c-1.2-.1-2.2-.4-3.2 0-.4.5-1.6.6-.2.8.6.5 3.7.2 3.8 1.2.8.8.6 1.9-.6 1.9a1.8 1.8 0 0 0-1.9 0l-3.5.1c2 .2-1.5-2.2-2.2-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "m321 138.7-1.6 1.1a30 30 0 0 0-3.2 2.2c-.6.5-.6.8-1.3.8 1.2-.1 1.8-.5 3-1 1.3-.2 2.6-.5 3.3-1.2.8-.2 0-1.3-.2-2zm12.2-13c.2 0 .5.7 1 1.3.5 1 .9 1.8.9 3.1.3-1.4.8-2.4 1-3.9-.4-.8-.4-1-1.6-1.1 0 .8.2.2-1.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c2",
    stroke: "#000",
    strokeWidth: 0.9,
    d: "M349.4 417.7c-.5 0 .8-.5 1.3-.6.4-.8.6-1.3 1.3-1.8 1.1 0 1.7.4 2.2 1.1 1 .3 1.3.7 2.4.9.5.4 1 .4 0 .7-.6.3-1.5.4-2.6.4a7.2 7.2 0 0 0-2.6.7c-1.5 0-1.3 0-2-1.4z",
    transform: "matrix(1.204 0 0 1.26 -95.6 -388.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M338 125.9v.3c0-.8 0-.4.3 1 .4 1 .5 2 .5 3.5a5.5 5.5 0 0 0 1.7-2.5c0-2.2-.4-2.2-2.5-2.3zm9.8 32h.3c-.8 0-.3 0 1-.8 1-.7 1.7-1.6 3-2a10.6 10.6 0 0 1 3.4-2c.7-.3 1.3-.7 2-.3-.2 1.4-.5 2-1.7 2.6-.6.8-1.5 1.3-2.4 1.6-.8.4-1.8.5-2.1 1.5-1.5.6-1.6.5-3.4-.6zm5.1 8 3-2.7a12.2 12.2 0 0 1 2.6-2.8c.8-1.2 1.8-2 2.4-3l2.1-2.8c0 1.2-.1 2.8.3 3.5a5.7 5.7 0 0 1-.8 3.4c-.6 1-1 1.6-2.5 2.3-1.1.6-1.9.8-2.8 1.6a21.2 21.2 0 0 1-2.5 1.4c-.7.3-.4.2-1.8-.8zm-8.3 6.4h.3c-.8 0-.4.1 1.1-.8 1.1-1.1 2-1.6 3.4-2.2a8.4 8.4 0 0 0 3.3-.8c.6-.2 1-.6 1.5 0 .9 1.1 1.1 1.5-.2 2.2a7.7 7.7 0 0 1-2.7 1.4c-.6.6-2 .6-3.3.8-1 0-1.6.2-2-.6l2.1.6c-1 0-1.6.2-3.5-.6zm11.4 0v-.2c0 .8 0 .4.6-1.2 1-1.5 1.4-2.4 2.7-2.7.6-.8 1.6-1 3-1.4.4.8 0 1.8 0 2.8-.4 1-1.4 1.7-2 2.5-.8.6-1 1.1-2.4 1.4-1 0-.4 0-1.8-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 136.2c0 .8-.5 1.4-1.3 1.4s-1.4-.6-1.4-1.4c0-.8.7-1.4 1.4-1.4.8 0 1.3.6 1.3 1.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#005120",
    fillRule: "evenodd",
    stroke: "#002b0d",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.8 479.6h.9c-2.8 0-1.1-.2 3.5 3.5 2-1.6 2-1.8 3.5 1 1 1.5 1.2-.2 2.7-1.8.7 3.2 1.1 6.5 3.5 3.5 2.8 0 5.6-.2 7.1.9 1.8 3.3 1.2-.6 2.6.9 4 .4 3.9-3.4 8.1-4.4 2.6 3.3 3.8.8 7-.8 2.5.6 4.8 4.3 5.3.7 2-3.2 2.1-3 3.5 0 2 1.8 2.8-.8 4.4-1.7 3 1.7 6.3 2 10.6.9.8 2.9 2.6 1.6 4.5.8 3.9 1.7 5.2 2.2 9.7 0 2.2-2.6 1 .1 2.6 1.8 3.3-1 2.4-1.2 6.2-.9 3.9 0 4.2 0 5.3-2.6 2 1.9 2.6 3.3 5.3.9 4.2 0 2.9.5 5.3-1 1.9 4 2.3 1.2 4.5 2.7a14.5 14.5 0 0 1-6.2 7c-1.7 3-2.8 6-6.2 7.2-2.5 2.5-5.2 4-8 6.2-3.8 1-8 .8-12.3.8H388c-2.6 1.4-7 2-10.6 2.7-4 0-8.7 0-11.5-.9-1.9-1.9-5.2-4-7-6.2-2-1.5-2-4.4-3.6-6.2-1.4-2.5-2-6.5-3.5-8.8z",
    transform: "matrix(1.204 0 0 1.26 -90.3 -390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5 487.6v.8c0-2.4.1-1.1-1.8 3.6-.3 1.1-1.2 1.4-2.6 1.8m-3.5-2.7h.9c-3.3 3-5.5 4.5-6.2 8l6.2-8c-3.3 3-5.5 4.5-6.2 8m-7.1-12.4s-.1 3.1-.9 4.4m-2.6 1.8v.8zm-7.1-5.3h.9-1c.4 0 .7 0 0 0zm-49.5 0c.4 0 2.2 2.8 4.4 4.4-.5 2.6-1.4 5.6 0 8m2.7-7.1c.4 0 2.1 2.8 4.4 4.4l-4.4-4.4c.4 0 2.1 2.8 4.4 4.4v.9c0-2.8-.2-5.6.9-7.1 1 1.7 2.2 4.3 2.6 1.8 5-.2 7.4-1.6 10.6-2.7 0 1.3-.2.7 1 1.8m60-3.6h.9c-1.7 1.4-3 4.3-4.4 6.2m-32.7-8.8h7",
    transform: "matrix(1.204 0 0 1.26 -90.3 -390)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M330.7 230c-12.8 0-17 13.4-29.8 13.4h-.8v.8c0 9.3.7 18 2 26 11.9-.8 16.2-13.4 28.6-13.4 12.8 0 17.1 13.4 29.9 13.4 12.8 0 17-13.4 29.8-13.4s17.1 13.4 30 13.4c12.7 0 17-13.4 29.8-13.4 12.3 0 16.7 12.4 28.5 13.3a154.7 154.7 0 0 0 2-26.6h-.7c-12.8 0-17-13.4-29.8-13.4s-17.2 13.4-29.9 13.4-17-13.4-29.9-13.4c-12.8 0-17 13.4-29.8 13.4-12.7 0-17.1-13.4-30-13.4zm0 52.3c-10 0-14.7 8.1-22.4 11.6a123.4 123.4 0 0 0 9.5 20.2 21 21 0 0 1 12.9-5c12.8 0 17.1 13.4 29.8 13.4 12.9 0 17.1-13.4 30-13.4 12.7 0 17 13.4 29.8 13.4 12.7 0 17-13.4 29.9-13.4a20.4 20.4 0 0 1 12.6 4.9 124.5 124.5 0 0 0 9.5-20.2c-7.5-3.6-12.3-11.5-22.1-11.5-12.8 0-17.2 13.3-30 13.3-12.7 0-17-13.3-29.8-13.3s-17 13.3-29.9 13.3c-12.8 0-17-13.3-29.8-13.3zm59.7 52.1c-12.8 0-17 13.5-29.8 13.5-12.1 0-16.6-12-27.9-13.3a144 144 0 0 0 43.8 32.6c4-3.1 8 3.7 13.8 3.7 6 0 10-6.9 13.9-3.9a143.6 143.6 0 0 0 43.4-32.3c-10.9 1.6-15.4 13.2-27.3 13.2-12.8 0-17-13.4-29.9-13.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.96 0 0 .96 -338.1 20.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M332.5 541.4a110 110 0 0 1 10.5-3l16.3 15.7-13.4 2.7z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.6,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3 6.7-31.1m-4.4 31.2 5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
    transform: "matrix(1.063 0 0 1.03 276.8 -178)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.4,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
    transform: "matrix(-1.255 0 0 1.762 1290.4 -502)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
    transform: "matrix(-1.255 0 0 1.312 1321.3 -302)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "m395.3 572.2.9-73s2.6-.3 2.6 0-.3 72.7-.6 73c-.3.3-3.2.5-2.9 0zm28.5-69.8-.6 61.3-2 2.4.6-63.7z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M363 560.2s3 30 36.4 29.1c33.4-.9 42.7-30.2 42.7-30.2l-14.5-.6c-.3 0-11.6 14-26.2 13.7-14.6-.3-19.2-3.8-22.4-6.7-3.2-3-6-7.3-6-7.3l-17-6.7 1 6.4zm90.3-3-1-4v-3.4l1.6-3.6s-25.3 3.7-25.3 4l-.1 6.8 24.8.1z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "m448.5 549.8-.6 6h4.1l-.3-6zm-4.3.3-.3 6.4 2.6-.3.3-6.1zm-4.4 6.4v-5l2.6-.9.3 5zm-5-.3.6-4.4 3 .3.2 4.7zm-5.5 0 .3-3.8 3-.3v4.4zm-67.4 3.7c.9 0 7.6 1.5 7.6 1.5l7 9.3",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M366.8 561.1c.3.3 6.1 19.8 34 19.8s34.6-22.1 34.6-22.1",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M439.8 559.4s-13.4 29-39 27c-25.5-2-29.6-11.6-31.6-16.6-2-5-3.2-9-3.2-9",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M373.2 558.2c.3-1.7.3-54.4.3-54.4l-1.7-.2-.3 53.7 1.7 1zm-41.5-17.1 22 10.7-.5 1.5S332 543.3 332 543c0-.3.2-1.5-.3-2z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M341.8 537.9c0 .8 3.2 18.6 3.2 18.6s2 .3 2 0l-3.4-18.3zm20.4.5c1.1 0 21-3.2 21-3.2l-.4 3.2-19.5 2z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M365 514.3c.7 0 7 3.2 9.7 2.4 2.7-.8.9-3 1.4-3 .6 0 2.6 1.5 3.8.3 1.2-1.1 2-4.6 1.5-4.3-.6.3-16 5.8-16.3 4.6z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M362.5 521.6c1.1.3 23.8-6.1 23.8-6.1s0 2-.3 2l-23.5 6.1z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M415 512.6s1.5 3.5 3 2.9c1.5-.6 2.9-1.8 2.9-1.8s1.2 3 3.2 2.4c2-.6 3.2-3.8 3.2-3.8s2 .6 2.9.3c.9-.3 2-5 2-5l-17.1 5zm-1.7 28.2c-.3.6 1.5 2 3 2s2-2 2.3-1.4c.3.5.3 3.2 4 2.3 3.7-.9 3.8-3.5 3.8-3.5s-1.1.9 1.5 1.2c2.6.3 5.2-3.8 5-3.8-.4 0-19 3.5-19.6 3.2z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M363.4 513.1a5 5 0 0 0 .2 2.7l19-6.4s.8-1.5 0-1.5-19.5 5.8-19.3 5.3zm25-4c.5 0 19.4-6.1 19.4-6.1s.3 2.6 0 2.6l-17.7 5.2-1.8-1.7z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.3 521.9s-2.9 3.2-2 7.5c.9 4.4 2 8.2 2.3 8.2.3 0 3.5-5.8 7-6.1 3.5-.3 9.9 3.2 9.9 3.2s-.9-7-.6-10.2c.3-3.2 5.2-8.7 5.2-8.7l-21.8 6z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M386.9 516.6s-.6 2.7-.3 2.7l24.7-6.4V511l-24.4 5.5z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6b4",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M355.5 551.8s-5.8-.8-5.5.6c.3 1.5 2.9 2.9 3.2 3.8.3.9-.9 4 .9 3.8 1.7-.3 3.4-1.5 3.4-2.4l-.3-5z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M387.8 537.3v2l20.9-2.9-.6-1.5z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M363 540.8c.4 0 0 2.6 2.4 2 2.3-.6 2.9-2 2.9-2s.6 3.2 3.8 2.9c3.2-.3 5-3.8 5-3.8s.2 2.6 2.2 1.7c2-.9 2.6-2.9 2.6-2.9l-18.3 2.6-.5-.5zm0-17.2s-2.6.9-1.7 6.1c.9 5.2 3 8.2 3.2 8.2.3 0 2.6-5 6.1-5.8 3.5-1 9.6 2.6 9.6 2.6s-.6-4.7.3-9a18 18 0 0 1 3.8-7.6s-20.4 5.5-21.2 5.5z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "m411.9 538.7.3 1.8s21-2.6 21-3c0-.2 0-2-.4-2-.3 0-20.6 3.5-21 3.2zm-.3-18.6.3 2 24.7-6.6s.6-1.8.3-1.8-24.7 7.3-25.3 6.4z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M414.2 510.8s-.3 1.8 0 1.8 18.3-4.4 18.3-4.7c0-.3 1.8-2 .3-1.7-1.4.3-18 5.5-18.6 4.6zm38.7 33.7-18-28.4m-2.4 19.7c.3-.8 1.2-18.3 1.2-18.3",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M389 510c1 .2 3.1 3.2 4.3 2.6 1.2-.6 2.9-2.4 2.9-2.4s-.3 3.5 2 3c2.4-.6 2.7-3 2.7-3s1.7 1 3.2 0c1.4-.8 2.8-5.2 2.3-5.2s-16.9 5.2-17.5 5zm-.6 8.4c0 .6-3 5.2-2 9.6 1 4.4 2.5 8.4 2.8 8.4.3 0 4.7-4.6 8.5-5.5 3.7-.9 9.3 2.9 9 2.9-.3 0-1.5-4.4-1.5-7.6 0-3.2 4.4-13 4.4-13zm0 21c0 .2.8 2.2 2.9 2.2 2 0 2.3-2 2.3-2s-.3 3.5 2.9 3.2c3.2-.3 4.3-3.5 4.3-3.5s.3 1.8 3 .9c2.6-.9 6-3.8 5.8-3.8-.3 0-21 3.8-21.3 3z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    width: 992.1,
    height: 496.1,
    transform: "translate(-6.6 7.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    width: 992.1,
    height: 496.1,
    transform: "translate(6.6 3.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    width: 992.1,
    height: 496.1,
    transform: "translate(0 11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    fill: "#be0f17",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.6,
    d: "M409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0z",
    transform: "matrix(.04 -1.072 1.024 .043 251.6 668)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M398.2 500c0-.2 9 3.8 9 4.1 0 .3 32 42.8 32.3 42.8m-16-42.8 8.2 3.5 2.6 6.4m-61.4-10.4c-.3 0 9 7 9 7l1.2 5.7M341.3 546c4-1.7 32.2-26.4 32.2-26.4m-39.8 21.7 31.7-26.7m21.2 4 30 49.8m-3.6-29.2s3.5 11.7 7 13.5a86 86 0 0 1 7.6 4.6",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M412.6 539.5s2.5 13.8 6 16.4c3.5 2.6 7 5.5 7 5.5",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M391 439s3.4 19.2 10.4 23.6a950 950 0 0 1 12.8 8.1",
    transform: "matrix(1.255 0 0 1.312 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M390.7 438.7s7.5 15.2 14 19.8c6.3 4.7 15 9 15 9M366.3 440c2 3.5 1.7 10.2 4 12.5a66 66 0 0 1 5.8 7.6m-9.3-19.9c1.2 1.7 4.4 10.4 6.4 13 1.5 2.4 16.3 17.2 16.3 17.2",
    transform: "matrix(1.255 0 0 1.312 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M384.6 471.1a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm10.7 4.7a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zM409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zm11.9-4.5c0 1-.7 1.7-1.6 1.7-.9 0-1.6-.8-1.6-1.7 0-.9.7-1.8 1.6-1.8.9 0 1.6.8 1.6 1.8zm9.6-5.7c0 .9-.9 1.6-1.9 1.6-1 0-1.9-.7-1.9-1.6 0-.9.9-1.6 1.9-1.6 1 0 1.9.7 1.9 1.6z",
    transform: "matrix(1.255 0 0 1.312 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M374.1 404.4c-.9.6-15.4 4.1-13.4 3.8 2-.3 13.7 3 13.4 2-.3-1 0-5.2 0-5.8zm24.7-4.3c-.6 0-9 3.2-8.7 3.2.3 0 9.6 2.6 9.3 2-.3-.6-.3-4.4-.6-5.2zm25.3 2.9c-.6.3-10.5 2.6-8.7 2.9 1.8.3 8.4 2.6 8.4 2 0-.5 0-4.6.3-5z",
    transform: "matrix(1.255 0 0 1.312 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
    transform: "matrix(1.255 0 0 1.312 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3 6.7-31.1m-4.4 31.2 5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
    transform: "matrix(1.255 0 0 1.363 225.3 -323.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
    transform: "matrix(-1.255 0 0 1.32 1259.2 -307.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "m426.4 558.5 27.6.6.3-2-28.5-.3zm1.2-7.3c3.2 0 27.3-4.6 27.3-4.6s.9-3 0-3-27.3 5.6-27.3 5.6z",
    transform: "matrix(1.255 0 0 1.312 259.4 -430)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    width: 992.1,
    height: 496.1,
    transform: "translate(0 5.5)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h256v256H0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M256 0v32l-95 96 95 93.5V256h-33.5L127 162l-93 94H0v-34l93-93.5L0 37V0h31l96 94 93-94z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "m92 162 5.5 17L21 256H0v-1.5zm62-6 27 4 75 73.5V256zM256 0l-96 98-2-22 75-76zM0 .5 96.5 95 67 91 0 24.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M88 0v256h80V0zM0 88v80h256V88z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M0 104v48h256v-48zM104 0v256h48V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk);
export default __webpack_public_path__ + "static/media/fk.61e9243020a0d2fd04f0b070e6bc1a67.svg";
export { ForwardRef as ReactComponent };